import PocoInitialCourts from './PocoInitialCourts';
import type { DraftPair } from '../../challenges/types/challengeDraft';
import { buildPocoRoundsFromPairs, type AdminRoundMatch } from '../../challenges/utils/pocoSchedule';

export function arrangePocoCategory(rounds: AdminRoundMatch[][], categoryKey: string, pairs: DraftPair[]) {
  const indices = rounds.flatMap((round, index) => round.some(match => match.categoryKey === categoryKey) ? [index] : []);
  if (!indices.length) return rounds;
  if (indices.some(index => rounds[index].some(match => [match.score1, match.score2].some(score => score !== '' && score != null)))) return rounds;
  const next = buildPocoRoundsFromPairs(pairs, rounds[indices[0]].length, false)
    .map(round => round.map(match => ({ ...match, categoryKey })));
  if (!next.length) return rounds;
  return rounds.flatMap((round, index) => index === indices[0] ? next : indices.includes(index) ? [] : [round]);
}

export default function PocoGeneratedCourtsEditor({ rounds, categoryKey, pairs, registeredPairs = [], disabled, onChange }: {
  rounds: AdminRoundMatch[][]; categoryKey: string; pairs: DraftPair[]; disabled: boolean;
  registeredPairs?: DraftPair[];
  onChange: (rounds: AdminRoundMatch[][]) => void;
}) {
  const category = rounds.filter(round => round.some(match => match.categoryKey === categoryKey));
  if (!category.length || category.some(round => round.some(match => [match.score1, match.score2].some(score => score !== '' && score != null)))) return null;
  const byId = new Map([...registeredPairs, ...pairs].map(pair => [pair.id, pair]));
  const ordered = category[0].flatMap(match => [match.dupla1Id, match.dupla2Id]).map(id => byId.get(id));
  if (ordered.some(pair => !pair)) return null;
  return <PocoInitialCourts pairs={ordered as DraftPair[]} disabled={disabled}
    onChange={next => onChange(arrangePocoCategory(rounds, categoryKey, next))} />;
}
